import {
  initialGoodwill, Goodwill, goodwillcolumnToPropertyMapping
} from './goodwill.model';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GoodwillColumns } from './goodwill.model';
type AOA = Array<Array<string | number>>;

export class GoodWillControl {
  /**
* @arg goodwillProduct to store an goodwills product
**/
  private goodwillProduct: Goodwill;
  /**
* @arg goodwillRequest to store goodwill api request
**/
  private apiRequest: Array<any>;
  /**
  * @arg tableData to store table data
  **/
  private tableData: Array<any>;
  /**
  * @arg titles to store raw titles from the raw data
  **/
  private titles: Array<string>;
  /**
  * @arg values to store raw values from the raw data
  **/
  private values: AOA;

  constructor(data: AOA) {
    this.setRawData(data);
    this.apiRequest = [];
  }
  /**
  * @method checkColumns checks if the columns have the required fields until the column description
  * @param columns columns of the raw data
  **/
  public static checkColumns(columns: Array<string>): boolean {
    let validData = true;
    GoodwillColumns.forEach(column => {
      validData = columns.some(function (element, i) {
        if (column === element.toLowerCase()) {
          return true;
        }
      });
    });
    return validData;
  }
  /**
  * @method setRawData sets the raw data to the model
  * @param data data to be set
  **/
  private setRawData(data: AOA): void {
    const columns = data[0] as Array<string>;
    this.titles = columns;
    this.values = data.splice(1);
  }
  /**
  * @method convertToRequest converts the raw data to the api request format
  **/
  private convertToRequest(): void {
    for (let row = 0; row < this.values.length; row++) {
      const rowData = this.values[row];
      if (rowData.length === this.titles.length) {
        this.parseRow(rowData);
        this.setApiRequests();
      }
    }
  }
  /**
  * @method setApiRequest sets the api request
  **/
  private setApiRequests() {
    const vin = this.goodwillProduct.vin;
    const subscriberGuid = this.goodwillProduct.subscriberGuid;
    const region = this.goodwillProduct.region;
    const generation = this.goodwillProduct.generation;
    delete this.goodwillProduct['vin'];
    delete this.goodwillProduct['subscriberGuid'];
    delete this.goodwillProduct['region'];
    delete this.goodwillProduct['generation'];
    this.goodwillProduct.term = parseInt(`${this.goodwillProduct.term}`);
    this.apiRequest.push({
      vin,
      subscriberGuid,
      region,
      generation,
      subscriptions: [this.goodwillProduct]
    });
  }
  /**
  * @method parseRow parses row data to pacakges product
  * @param rowData rowdata
  **/
  private parseRow(rowData: Array<string | number>): void {
    this.resetGoodwill();
    for (let index = 0; index < rowData.length; index++) {
      this.setGoodwillDetails(index, rowData[index]);
    }
  }
  /**
  * @method resetProducts resets the goodwill product
  **/
  private resetGoodwill(): void {
    const clone = JSON.stringify(initialGoodwill);
    const defaultgoodwill = JSON.parse(clone);
    this.goodwillProduct = defaultgoodwill;
  }
  /**
  * @method setGoodwillDetails sets the goodwill details
  * @param index column index
  * @param value value to be stored
  **/
  public setGoodwillDetails(index, value): void {
    const mapping = this.getProperty(index);
    if (!!mapping) {
      this.goodwillProduct[mapping] = `${value}`;
    }
  }
  /**
  * @method getProperty gets the property keys for the api request from the columntoProperty mapping
  * @param index column index
  **/
  private getProperty(index): string {
    return goodwillcolumnToPropertyMapping[this.titles[index].toLowerCase().trim()];
  }
  /**
  * @method getApiRequest returns the api request
  **/
  public getApiRequests(): Array<any> {
    this.convertToRequest();
    return this.apiRequest;
  }
  /**
   * @method getEndpoint get the goodwill api
   */
  public get getEndpoint() {
    return environment.bulk.goodwill.apis.postGoodwill;
  }
  /**
  * @method getApitype returns api type
  * @returns object
  **/
  public get getApiType(): object {
    return { type: 'goodwill' };
  }
}
